<stb-modal
  [noPMargins]="true"
  [rebrand]="true"
  [isShowing]="true"
  [large]="true"
  [primaryText]="steps[step].fmsKey | fms"
  (primaryClick)="goNext()"
  [primaryTrackId]="'groupAndMarketingConsent.dialog.next'"
  [cancelText]="step === consentKeys.MARKETING ? ('consents.button.back' | fms) : null"
  (cancelClick)="step === consentKeys.MARKETING ? goBack() : null"
  [cancelTrackId]="'groupAndMarketingConsent.dialog.back'"
  [header]="
    step === consentKeys.GROUP
      ? ('consentText.consents.enterprise.title' | fms)
      : ('consentText.consents.electronicSolicitation.title' | fms)
  "
  [isLoading]="isSubmitting"
  [primaryButtonDisabled]="isSubmitting"
>
  @switch (step) {
    @case (consentKeys.GROUP) {
      <p>{{ "consentText.consents.enterprise.description" | fms }}</p>

      <stb-accordion class="" [rebrand]="true">
        <stb-accordion-item
          [rebrand]="true"
          [headerText]="'consentText.consents.accordion.storebrand.title' | fms"
          [trackId]="'link-consentText.consents.accordion.storebrand.title' | fms"
        >
          <div [innerHTML]="'consentText.consents.accordion.storebrand.description' | fms | formatTextForConsent"></div>
        </stb-accordion-item>
        <stb-accordion-item
          [rebrand]="true"
          [headerText]="'consentText.consents.accordion.information.title' | fms"
          [trackId]="'link-consentText.consents.accordion.information.title' | fms"
        >
          <div
            [innerHTML]="'consentText.consents.accordion.information.description' | fms | formatTextForConsent"
          ></div>
        </stb-accordion-item>
      </stb-accordion>
      <br />
      @if (groupRadioButtons$ | async; as groupRadioButtons) {
        <stb-radio-buttons
          [rebrand]="true"
          [legend]="'consentText.consents.enterprise.label' | fms"
          name="groupConsentRadio"
          [horizontal]="true"
          [group]="groupRadioButtons"
          [message]="'onboardingConsents.dataStorage.error' | fms"
          [warning]="groupConsentControl.invalid && groupConsentControl.touched"
          (valueChanged)="setControlValue(groupConsentControl, $event)"
          data-trackid="link-onboarding-dataStorage-radioButton"
        >
        </stb-radio-buttons>
      }
    }
    @case (consentKeys.MARKETING) {
      <p>{{ "consentText.consents.electronicSolicitation.description" | fms }}</p>
      <stb-accordion class="" [rebrand]="true">
        <stb-accordion-item
          [rebrand]="true"
          [headerText]="'consentText.consents.accordion.storebrand.title' | fms"
          [trackId]="'link-consentText.consents.accordion.storebrand.title' | fms"
        >
          <div [innerHTML]="'consentText.consents.accordion.storebrand.description' | fms | formatTextForConsent"></div>
        </stb-accordion-item>
        <stb-accordion-item
          [rebrand]="true"
          [headerText]="'consentText.consents.accordion.electronic.title' | fms"
          [trackId]="'link-consentText.consents.accordion.electronic.title' | fms"
        >
          <div [innerHTML]="'consentText.consents.accordion.electronic.description' | fms | formatTextForConsent"></div>
        </stb-accordion-item>
      </stb-accordion>
      <br />
      @if (marketingElectronicRadioButtons$ | async; as marketingElectronicRadioButtons) {
        <stb-radio-buttons
          [rebrand]="true"
          [legend]="'consentText.consents.electronicSolicitation.label' | fms"
          name="marketingElectronicConsentRadio"
          [horizontal]="true"
          [group]="marketingElectronicRadioButtons"
          [message]="'onboardingConsents.dataStorage.error' | fms"
          [warning]="marketingElectronicConsentControl.invalid && marketingElectronicConsentControl.touched"
          (valueChanged)="setControlValue(marketingElectronicConsentControl, $event)"
          data-trackid="link-onboarding-dataStorage-radioButton"
        >
        </stb-radio-buttons>
        <br />
      }
      @if (marketingSocialMediaRadioButtons$ | async; as marketingSocialMediaRadioButtons) {
        <stb-radio-buttons
          [rebrand]="true"
          [legend]="'consentText.consents.socialMediaSolicitation.label' | fms"
          name="marketingSocialMediaConsentRadio"
          [horizontal]="true"
          [group]="marketingSocialMediaRadioButtons"
          [message]="'onboardingConsents.dataStorage.error' | fms"
          [warning]="marketingSocialMediaConsentControl.invalid && marketingSocialMediaConsentControl.touched"
          (valueChanged)="setControlValue(marketingSocialMediaConsentControl, $event)"
          data-trackid="link-onboarding-dataStorage-radioButton"
        >
        </stb-radio-buttons>
      }
    }
  }
</stb-modal>
